import type { IFileUploadProps } from "../../pages/first-line/ChatForm.interface";
import { FileUpload } from "../FileUpload";

const ChatFileTab = ({ leadId }: IFileUploadProps) => {
  return <FileUpload leadId={leadId}></FileUpload>;
};

export default ChatFileTab;
